<template>
  <div id="app" :class="appLayoutClasses" class="app-footer-relative-container">
    <!-- <m-drawer dismissible v-model="open">
      <m-drawer-header slot="header" sub-title="email@material.io" title="" />
      <m-drawer-content>
        <m-drawer-list>
          <m-list-item activated tabindex="0">
            <m-icon icon="home" slot="graphic" />
            Inicio - Buscador
          </m-list-item>
          <m-list-group-divider />
          <m-list-group-subheader>Tipos de inmuebles</m-list-group-subheader>
          <m-list-item>
            <m-icon icon="bookmark" slot="graphic" />
            Suelo residencial
          </m-list-item>
          <m-list-item>
            <m-icon icon="bookmark" slot="graphic" />
            Suelo industrial
          </m-list-item>
          <m-list-item>
            <m-icon icon="bookmark" slot="graphic" />
            Suelo terciario
          </m-list-item>
          <m-list-item>
            <m-icon icon="bookmark" slot="graphic" />
            Viviendas
          </m-list-item>
          <m-list-item>
            <m-icon icon="bookm      
          </m-list-item>
          <m-list-item>
            <m-icon icon="settings" slot="graphic" />
            Garajes
          </m-list-item>
          <m-list-item>
            <m-icon icon="bookmark" slot="graphic" />
            Trasteros
          </m-list-item>
          <m-list-group-divider />
          <m-list-item>
            <m-icon icon="announcement" slot="graphic" />
            Información y contacto
          </m-list-item>
        </m-drawer-list>
      </m-drawer-content>
    </m-drawer> -->
    <m-drawer-app-content
      class="app-background-image app-footer-relative-wrapper"
    >
      <m-top-app-bar
        @nav="open = !open"
        class="drawer-top-app-bar app-mdc-top-app-bar"
        title="Junta de Andalucía - Catálogo de Bienes Inmuebles de AVRA"
        titleMobile="Catálogo de Bienes Inmuebles"
        v-on:titleClick="onTitleClick()"
      >
        <!-- <m-icon-button
          icon="menu"
          slot="navigation"
          class="mda-hide-on-desktop"
        /> -->
        <!-- <m-icon-button icon="menu" slot="navigation" /> -->
        <template slot="actions">
          <app-search-full v-on:searchFullSubmitted="searchFullSubmitted" />
          <!-- <m-icon-button icon="search" /> -->
        </template>
      </m-top-app-bar>
      <div class="drawer-main-content">
        <m-top-app-bar-fixed-adjust />
        <router-view />
        <div>
          <cookie-law
            theme="blood-orange--rounded"
            buttonText="Aceptar"
            buttonClass="mdc-button mdc-button--raised"
            position="bottom"
          >
            <div slot="message">
              Esta web instala cookies con la única y exclusiva finalidad de
              elaborar informes de carácter estadístico y analizar la actividad
              realizada para mejorar nuestro servicio. No se usan para
              identificar a la persona que accede, tienen una vigencia temporal
              limitada y en ningún caso se utilizan para recoger información de
              carácter personal. Puede usted rechazar el uso de cookies en la
              configuración de su navegador, sin embargo, le informamos que si
              lo hace puede verse reducida la plena funcionalidad de esta web.
            </div>
          </cookie-law>
        </div>
      </div>
    </m-drawer-app-content>
    <div class="app-footer">
      <m-layout-grid>
        <m-layout-grid-inner>
          <m-layout-grid-cell
            :span-phone="4"
            :span-tablet="8"
            :span-desktop="6"
          >
            <div class="app-footer__logo-organization">
              <img
                src="./assets/logo-white-no-label--new.png"
                alt="Logo Junta de Andalucía"
              />
            </div>
            <div class="app-footer__title-organization">
              <div class="app-footer__title-organization__junta">
                Junta de Andalucía
              </div>
              <div class="app-footer__title-organization__consejeria">
                Consejería de Fomento, Articulación del Territorio y Vivienda
              </div>
              <div class="app-footer__title-organization__avra">
                AGENCIA DE VIVIENDA Y REHABILITACIÓN DE ANDALUCÍA
              </div>
            </div>
          </m-layout-grid-cell>
          <m-layout-grid-cell
            :span-phone="4"
            :span-tablet="8"
            :span-desktop="6"
            class="app-footer__enlaces"
          >
            <a
              target="_blank"
              title="Este enlace abre una nueva ventana"
              class="app-link--open-in-new  app-link--open-in-new--footer"
              href="http://www.juntadeandalucia.es/avra/opencms/general/avisoLegal.html"
              >Aviso legal</a
            >
            <a
              target="_blank"
              title="Este enlace abre una nueva ventana"
              class="app-link--open-in-new  app-link--open-in-new--footer"
              href="http://www.juntadeandalucia.es/avra/opencms/general/politica-privacidad.html"
              >Política de privacidad</a
            >
            <a
              href="./declaracion_conformidad_ENS_Basica_2026_05_15_F.pdf"
              target="_blank"
              title="Declaración de conformidad con el ENS - Categoría Básica RD 311/2022"
              class="app-footer__ens-seal"
            >
              <img
                src="./assets/sello_ens_declaracion_BASICA_RD311-2022.png"
                alt="Sello ENS - Esquema Nacional de Seguridad - Categoría Básica RD 311/2022"
              />
            </a>
          </m-layout-grid-cell>
        </m-layout-grid-inner>
      </m-layout-grid>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueMaterialApp from "./components/vue-material-app";
import Vuelidate from "vuelidate";
import CookieLaw from "vue-cookie-law";
// import { bootstrap } from "vue-gtag";

// Componentes de aplicación (o sitio web)
import AppInmueblesListItem from "./components/AppInmueblesListItem";
import AppLayoutGridInnerCustom from "./components/AppLayoutGridInnerCustom";
import AppPortadaBuscadorFiltro from "./components/AppPortadaBuscadorFiltro";
import AppPortadaBuscadorSimple from "./components/AppPortadaBuscadorSimple";
import AppInmueblesListFilterFull from "./components/AppInmueblesListFilterFull";
import AppMapaInmuebles from "./components/AppMapaInmuebles";
import AppSearchFull from "./components/AppSearchFull";

Vue.use(Vuelidate);
Vue.use(VueMaterialApp);

// Para evitar cortar y pegar codigo repetitivo
var appComponents = [
  AppInmueblesListFilterFull,
  AppInmueblesListItem,
  AppLayoutGridInnerCustom,
  AppMapaInmuebles,
  AppPortadaBuscadorFiltro,
  AppPortadaBuscadorSimple,
  AppSearchFull
];

appComponents.forEach(componentElement => {
  Vue.component(componentElement.name, componentElement);
});

// no se necesita ahora se envia todo por route import AppEventBus from "./components/AppEventBus.js";

export default {
  components: { CookieLaw },
  data() {
    return {
      open: false // change to true to open the drawer
    };
  },
  computed: {
    isPortada() {
      return this.$route.path === "/";
    },
    appLayoutClasses() {
      return this.$route.path === "/"
        ? { "app-layout--with-background-img": true }
        : {};
    }
    // watch: {
    //   $route() {
    //     this.appLayoutClasses =

    //   }
  },
  created() {
    // Inicializamos todo lo necesario del framework para la app

    // this.$mdApp.log.setDefaultLevel(this.$mdApp.log.levels.DEBUG);
    this.initApp();
  },
  methods: {
    /**
     * Realiza las inicializaciones necesarias para que funcione todo el framework dependiendo de las propiedades pasadas
     */
    initApp() {
      var appConfig = {
        dataaccessConfig: this.$mdApp.dataAccess.predefinedConfigs
          .opencmsWebProd
        // dataaccessConfig: this.$mdApp.dataAccess.predefinedConfigs.opencmsWebDevjdaWithLocalhostProxy,
        // dataaccessConfig: this.$mdApp.dataAccess.predefinedConfigs.opencmsWebDev,
        // dataaccessConfigAdditionalPath: "uxtest-20201014"
        // dataaccessConfigAdditionalPath: "catalogo-inmuebles-oferta-sin-publicar"
        // dataaccessConfigAdditionalPath: "catalogo-pre"
        // dataaccessConfigAdditionalPath: "catalogo-dev"

        // dataaccessConfigAdditionalPath: "gestionactivos"
      };
      this.initDataAccess(appConfig);
    },
    initDataAccess(appConfig) {
      var defaultDataAccessConfig = appConfig.dataaccessConfig;

      // Si se ha pasado un directorio para la app, hay que añadirlo a la configuración del dataAccess
      if (appConfig.dataaccessConfigAdditionalPath) {
        defaultDataAccessConfig.additionalPath =
          appConfig.dataaccessConfigAdditionalPath;
      }
      // Inicializamos el acceso a dato
      this.$mdApp.dataAccess.setDefaultConfig(defaultDataAccessConfig);
    },
    // de moemnto no hace flata activar el script
    // onAcceptCookiesBanner() {
    //   // Activamos el script de google analytics
    //   bootstrap().then(gtag => {
    //     var baseUrl4PageView = window.location.href.replace(
    //       window.location.hash ? "/" + window.location.hash : "",
    //       ""
    //     );
    //     var url4PageView = baseUrl4PageView + this.$route.fullPath;

    //     var pageViewOptions = {
    //       page_title: this.$route.name,
    //       page_path: this.$route.path,
    //       page_location: url4PageView
    //     };
    //     // No se había registrado este pageview pq estbaan desactivadas
    //     gtag.pageview(pageViewOptions);
    //   });
    // },
    searchFullSubmitted(searchfullText) {
      this.$router.push(
        this.routerLinkTotViewWithFilter(
          "/inmuebles",
          searchfullText ? searchfullText.trim() : ""
        )
      );
    },
    routerLinkTotViewWithFilter(path, searchfullText) {
      var queryParams = {
        busqueda: searchfullText
      };

      return { path: path, query: queryParams };
    },
    onTitleClick() {
      this.$router.push({ name: "portada" });
    }
  }
};
</script>

<style lang="scss">
@import "./components/vue-material-app/styles";
@import "@material/layout-grid/mdc-layout-grid.scss";

@media (max-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-layout--with-background-img {
    /* si es la portada para dispositivos moviles se muestra el logo de la junta */
    .mdc-top-app-bar--fixed-adjust {
      height: 80px !important;
    }
  }
}

@media (max-device-width: 500px) {
  .mdc-top-app-bar {
    .app-footer__title-organization {
      width: 220px;
    }
    .app-footer__title-organization {
      font-size: 0.7em;
    }

    .mdc-top-app-bar__section.mdc-top-app-bar__section--align-end {
      max-width: 50px; /* Para que no se coma el logo en portada */
    }
  }
}

.mdc-top-app-bar.app-mdc-top-app-bar {
  font-family: "Roboto Black", "Roboto";
}

// CON LOS BREAKPOINTS QUE NO UNFCIONABA
// // Img de brackgroun que se ve al fondo
// .app-layout--with-background-img {
//   // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
//   // Si la metes en assets y la refernecia te la empaqueta inline
//   .app-background-image {
//     background: url("./assets/home-background-img-2.webp");
//     background-size: auto 719px;
//     background-repeat: no-repeat;
//   }
// }

// @media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
//   .app-layout--with-background-img {
//     // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
//     // Si la metes en assets y la refernecia te la empaqueta inline
//     .app-background-image {
//       background: url("./assets/home-background-img-2.webp");
//       background-size: auto 719px;
//       background-repeat: no-repeat;
//     }
//   }
// }

// @media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
//   .app-layout--with-background-img {
//     .mdc-top-app-bar.app-mdc-top-app-bar {
//       --mdc-theme-primary: none; //Para hacer "transparente" la cabecera y que se vea la imagen
//       .app-background-image {
//         // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
//         // Si la metes en assets y la refernecia te la empaqueta inline
//         background: url("./assets/home-background-img-2.webp");
//         background-size: 100% auto;
//         background-repeat: no-repeat;
//       }
//     }
//   }
// }

.app-layout--with-background-img {
  .mdc-top-app-bar.app-mdc-top-app-bar {
    --mdc-theme-primary: none; //Para hacer "transparente" la cabecera y que se vea la imagen
  }
}

// Img de brackgroun que se ve al fondo
// Funcionando
// .app-layout--with-background-img {
//   .app-background-image {
//     // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
//     // Si la metes en assets y la refernecia te la empaqueta inline
//     background: url("./assets/home-background-img-2.webp");
//     background-size: 100% auto;
//     background-repeat: no-repeat;
//   }
// }

// @media (max-device-width: 1366px) {
//   .app-layout--with-background-img {
//     // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
//     // Si la metes en assets y la refernecia te la empaqueta inline
//     .app-background-image {
//       background: url("./assets/home-background-img-2.webp");
//       background-size: auto 719px;
//       background-repeat: no-repeat;
//     }
//   }
// }

.app-layout--with-background-img {
  // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
  // Si la metes en assets y la refernecia te la empaqueta inline
  .app-background-image {
    background: url("./assets/home-background-img-2.jpg");
    background-size: auto 719px;
    background-repeat: no-repeat;
  }
}

// Cuando el ancho es mayor que la imagen la ensanchamos al 100% si no
@media (min-device-width: 1440px) {
  .app-layout--with-background-img {
    .app-background-image {
      // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
      // Si la metes en assets y la refernecia te la empaqueta inline
      background: url("./assets/home-background-img-2.jpg");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}

// Si está soportado webp se usa mejor la imagen webp, que pesa 100k's menos (el script de index.html pone esta clase .webp si es soportado)
// usando https://raoulkramer.de/webp-image-and-background-usage-in-web-projects/
.webp .app-layout--with-background-img {
  // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
  // Si la metes en assets y la refernecia te la empaqueta inline
  .app-background-image {
    background: url("./assets/home-background-img-2.webp");
    background-size: auto 719px;
    background-repeat: no-repeat;
  }
}

// Cuando el ancho es mayor que la imagen la ensanchamos al 100% si no
@media (min-device-width: 1440px) {
  .webp .app-layout--with-background-img {
    .app-background-image {
      // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
      // Si la metes en assets y la refernecia te la empaqueta inline
      background: url("./assets/home-background-img-2.webp");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}

.transition-fade-enter-active,
.transition-fade-leave-active {
  transition: opacity 0.2s;
}
.transition-fade-enter, .transition-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// Esto es pq algunos navegadores ie11 y chrome antiugos no cogen la maily bien
// mdc-top-app-bar {
//   font-family: "Roboto";
// }

* {
  font-family: "Roboto";
}

// Los hacks de IE11... :(
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // Img de brackgroun que se ve al fondo
  .app-layout--with-background-img {
    .mdc-top-app-bar.app-mdc-top-app-bar {
      background-color: rgba(255, 255, 255, 0);
    }
    .app-background-image {
      // Esto se hace absoluto para coger la img del public y no la
      background-repeat: no-repeat;
    }
  }
}

@media (min-device-width: 1440px) and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {
  .app-layout--with-background-img {
    // Esto se hace absoluto para coger la img del public y no la empaquete pq es muy grande y habría que cargar mucho para empezar
    // Si la metes en assets y la refernecia te la empaqueta inline
    .app-background-image {
      background: url("./../public/home-background-img-2.jpg");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}

// Para situar bien el alto del contenido y el footer
.app-footer-relative-container {
  // según peaso articulo https://www.freecodecamp.org/news/how-to-keep-your-footer-where-it-belongs-59c6aa05c59c/
  position: relative;
  // min-height: calc(100vh-56px); // Le quitamos el top-bar
  min-height: 100vh; // Le quitamos el top-bar
}

.app-footer-relative-wrapper {
  padding-bottom: 120px;
}

.app-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  // height: 64px;
  background-color: #263238;
  color: white;
}

.app-footer__logo-organization {
  display: inline-block;
  vertical-align: middle;
}

.app-footer__logo-organization img {
  width: 35px;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-footer__logo-organization img {
    width: 50px;
  }
}

.app-footer__ens-seal {
  display: inline-block;
  margin-left: 1em;
  vertical-align: middle;
}

.app-footer__ens-seal img {
  width: 70px;
}

@media (max-device-width: map-get($mdc-layout-grid-breakpoints, "phone")) {
  .app-footer__ens-seal {
    display: block;
    margin: 1em auto 0;
  }
}

.app-footer__title-organization {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: 14px;
  padding-bottom: 1em;
  margin-left: 1em;
  font-size: 0.6em;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "tablet")) {
  .app-footer__title-organization {
    font-size: 1em;
  }
}

.app-footer__title-organization__junta {
  font-family: "Noto Sans HK", "Roboto", sans-serif;
  font-weight: 700;
  font-size: 1em;
}

.app-footer__title-organization__consejeria {
  margin-top: 0.5em;
  font-family: "Noto Sans HK", "Roboto", sans-serif;
  font-weight: 400;
  font-size: 0.7em;
}

.app-footer__title-organization__avra {
  margin-top: 0.7em;
  font-family: "Noto Sans HK", "Roboto", sans-serif;
  font-weight: 400;
  font-size: 0.5em;
  margin-bottom: 0.2em;
}

// Para textos de "esperando..." (solucion cutre mientras pongo el spinner...)
.blinking {
  animation: blinkingText 2s infinite;
}
@keyframes blinkingText {
  0% {
    color: #607d8b;
  }
  49% {
    color: transparent;
  }
  50% {
    color: transparent;
  }
  59% {
    color: transparent;
  }
  100% {
    color: #607d8b;
  }
}

// Para añadir "paragüitas" a title

// .mdc-top-app-bar__title:before {
//   content: "";
//   display: block;
//   background: url("./assets/logo-white-no-label.png") no-repeat;
//   width: 25px;
//   height: 25px;
//   float: left;
//   z-index:100000; /*a number that's more than the modal box*/
// }

.mdc-top-app-bar__title {
  font-family: "Noto Sans HK", "Roboto";
  font-weight: 400;
}

.mdc-top-app-bar__title:before {
  content: url("./assets/logo-white-no-label--title-new.png");
  margin-right: 0.5em;
  float: left;
}

.app-linkable:hover {
  cursor: pointer;
}

.app-footer__enlaces {
  text-align: right;
  line-height: 30px;
  text-align:center;
}

.app-link--open-in-new.app-link--open-in-new--footer {
  margin-left: 1em;
  font-size: 0.9em;
  color: white;
}
</style>
